<template lang="pug">
  v-flex
    v-container
      v-layout
        v-text-field(v-model='search' prepend-icon='fa-search' label='Buscar código' single-line hide-details)
      v-layout.mt-5   
          h2 Balance general
      v-row.mt-4
          v-col
              v-data-table.elevation-1(:headers="headers" :search='search' :items='registro_balance_activo' hide-default-footer)
                template( v-slot:item.saldo="{item}")
                  span {{Object.keys(item.saldo).map(llave=>item.saldo[llave].saldo).reduce((a, b)=>(a>0) ? a : a*-1+(b>0) ? b : b*-1, 0)}}
              v-chip(color='primary').mt-4 Total debe:  {{registro_balance_activo.map(item=>Object.keys(item.saldo).map(llave=>item.saldo[llave].saldo).reduce((a, b)=>a+b, 0)).reduce((a, b)=>(a>0) ? a : a*-1+(b>0) ? b : b*-1, 0)}}
          v-col
              v-data-table.elevation-1( :headers="headers" :search='search' :items='registro_balance_pasivo' hide-default-footer)
                template( v-slot:item.saldo="{item}")
                  span {{Object.keys(item.saldo).map(llave=>item.saldo[llave].saldo).reduce((a, b)=>(a>0) ? a : a*-1+(b>0) ? b : b*-1, 0)}}
              v-chip(color='primary').mt-4 Total haber:  {{((Number(registro_balance_pasivo.map(item=>Object.keys(item.saldo).map(llave=>item.saldo[llave].saldo)).reduce((a, b)=>Number(a)+Number(b), 0).toFixed(2))) > 0) ? Number(registro_balance_pasivo.map(item=>Object.keys(item.saldo).map(llave=>item.saldo[llave].saldo)).reduce((a, b)=>Number(a)+Number(b), 0).toFixed(2)) : Number(registro_balance_pasivo.map(item=>Object.keys(item.saldo).map(llave=>item.saldo[llave].saldo)).reduce((a, b)=>Number(a)+Number(b), 0).toFixed(2)) * -1 }}              
      v-layout.mt-5   
          h2 Estado de resultados
      v-layout.mt-4
          v-col
              v-data-table.elevation-1( :headers="headers" :search='search' :items='registro_estado_resultado' hide-default-footer)
                template( v-slot:item.saldo="{item}")
                  span {{Object.keys(item.saldo).map(llave=>item.saldo[llave].saldo).reduce((a, b)=>a+b, 0)}}

</template>
<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import {coleccion_de_periodo_contable, coleccion_partidas_contables} from '@/FirebaseConfig'
export default {
    data: ()=>({
        search: '',
        headers: [
            { text: 'Código', value: 'codigo', sortable: false },       
            { text: 'Descripción',  value: 'descripcion', sortable: false},              
            { text: 'Saldo',  value: 'saldo', sortable: false}
        ],
    }),
       computed:{
      ...mapGetters({
        registro_balance_activo: 'Partidas_Contables/registro_balance_activo',
        registro_balance_pasivo: 'Partidas_Contables/registro_balance_pasivo',
        registro_estado_resultado: 'Partidas_Contables/registro_estado'
      }),
    },
}
</script>
